import { MatTooltipDefaultOptions } from '@angular/material/tooltip';

export const tooltipDefaultOptions: MatTooltipDefaultOptions = {
  showDelay: 750,
  hideDelay: 250,
  touchGestures: 'auto',
  touchendHideDelay: 500,
};